/**
 * "Remember me" on the sign-in form.
 *
 * The manager app keeps the mobile number *and* the password, in the platform
 * keystore. There is no equivalent on the web: localStorage is readable by any
 * script that gets onto the page, so a stored password would turn one XSS into
 * every visitor's account. Only the number is kept here, and the password is
 * left to the browser's own credential manager — which is what the
 * autoComplete hints on the form are for, and which is encrypted at rest and
 * bound to the origin.
 *
 * The effect the manager asked for is the same: sign out, come back, and the
 * form is already filled in.
 */
const KEY = 'bms-remember-phone';

export const rememberedPhone = (): string => {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return ''; // private mode
  }
};

/** Passing an empty number clears it — unticking the box must actually forget. */
export function setRememberedPhone(phone: string) {
  try {
    if (phone) localStorage.setItem(KEY, phone);
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode: nothing to remember it with */
  }
}
